import React from 'react';
import { Box, Divider, Paper, Typography } from '@mui/material';

export const DetailSection = ({ title, icon, children }) => (
  <Box className="wivi-detail-section" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <Box className="wivi-detail-section-header" sx={{ justifyContent: 'center', width: '100%' }}>
      <Box className="wivi-detail-section-icon">{icon}</Box>
      <Typography variant="h6" fontWeight={600} color="text.primary">
        {title}
      </Typography>
    </Box>
    <Divider sx={{ mb: 3, width: '100%' }} />
    <Box className="wivi-detail-section-content" sx={{ width: '100%' }}>
      {children}
    </Box>
  </Box>
);
